'use client';

import { __styles } from '@griffel/react';
import { typographyStyles } from '@fluentui/react-theme';
export const displayClassNames = {
  root: 'fui-Display'
};
/**
 * Styles for the root slot
 */
export const useDisplayStyles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fpyltcb",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "f1ivgwrt"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fpyltcb{font-size:var(--fontSizeHero1000);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".f1ivgwrt{line-height:var(--lineHeightHero1000);}"]
});